exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-top{\n    font-size: 3em;\n}\na:hover{\n color:#1ebbf0;\n}\n.col-sm-4{\n    padding-top: 15px;\n}\nul{\n    list-style: none; position: relative; float: left; display: block; left: 50%;\n    \n}\nul li {\n    position: relative; float: left; display: block; right: 50%;\n}\n.card-body{\n    padding-left: 15px;\n    padding-right: 15px;\n    padding-top: 10px;\n    text-align: left;\n}\na.meta{\n    padding-left: 5px;\n    padding-right: 5px;\n    font-size: 15px;\n    color:#adb0b6;\n    font-family: \"Open Sans\", Helvetica, Arial, Verdana, sans-serif;\n}\np.card-text:hover{\n    color: #1ebbf0;\n}\n.card-text{\n    font-family: Roboto, Helvetica, Arial, Verdana, sans-serif;\n    font-size: 20px;\n}\n.entry-meta{\n    font-size: 13px;\n    line-height: 25px;\n    padding-top: 10px;\n    text-align: center;\n}\n.entry-meta:before {\n    width: 26px;\n    height: 26px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/news/hotnews/hotnews.component.css
// module id = 899
// module chunks = 0